module.exports = __webpack_public_path__ + "static/media/app-profile.e4c53b93.jpeg";